'use strict';

angular.module('supervisorAccessReviewRoutes', ['supervisorAccessReviewControllers',
                                                'services.accessReview',
                                                'services.systemToReviews',
                                                'services.authenticatedUser',
                                                'services.appParam'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('accessReview', {
            url: '/AccessReview',
            template: '<div ui-view/>',
            controller: 'AccessReviewController',
            resolve: {
                authUser: ['authenticatedUserService', function (service) {
                    return service.getAuthenticatedUser();
                }]
            }
        })

        .state('accessReview.noAccessReview', {
            url: '/NoAccessReview',
            templateUrl: require('./noAccessReview.tpl.html')
        })

        .state('accessReview.noAccessReviewForEmployee', {
            url: '/NoAccessReviewEmployee',
            templateUrl: require('./noAccessReviewForEmployee.tpl.html')
        })

        .state('accessReview.authUser', {
            url: '/:authLogin',
            template: '<div ui-view/>',
            controller: 'AccessReviewAuthUserController',
            resolve: {
                accessReview: ['accessReviewService', function (accessReviewService) {
                    return accessReviewService.getCurrentAccessReview();
                }],
                authLogin: ['$stateParams', 'authUser', function ($stateParams, authUser) {
                    var authLogin = $stateParams.authLogin;
                    var realAuthLogin = authUser.IdentityName;

                    if (_.isEmpty(authLogin)) return realAuthLogin;

                    if (authLogin.toUpperCase() !== realAuthLogin.toUpperCase() &&
                        !authUser.IsInAdministrationGroup) {

                        authLogin = realAuthLogin;
                    }

                    return authLogin;
                }]
            }
        })

        .state('accessReview.authUser.welcome', {
            url: '/Welcome',
            controller: 'Welcome_SystemToReviewCtrl',
            templateUrl: require('./welcome.tpl.html'),
            resolve: {
                nextSystemToReview: ['authLogin', 'systemToReviewService', function (authLogin, systemToReviewService) {
                    return systemToReviewService.getNextSystemRoleToReview(authLogin)
                                                .then(function (response) {
                                                    return response.data;
                                                });
                    }],
                systemRoleID: ['nextSystemToReview', function (nextSystemToReview) {
                    if (_.isUndefined(nextSystemToReview.SystemRole)) return null;
                    return nextSystemToReview.SystemRole.SystemRoleID;
                }],
                stateAccessReview: ['authLogin', 'systemToReviewService', function (authLogin, systemToReviewService) {
                    return systemToReviewService.getStateAccessReview(authLogin);
                }],
            }
        })

        .state('accessReview.authUser.systemToReview', {
            url: '/SystemToReview',
            template: '<div ui-view/>',
            controller: 'NextSystemToReviewController',
            resolve: {
                systemsToReview: ['authLogin', 'systemToReviewService', function (authLogin, systemToReviewService) {
                    return systemToReviewService.getSystemsAndSystemRolesToReview(authLogin);
                }],
                nextSystemToReview: ['authLogin', 'systemToReviewService', function (authLogin, systemToReviewService) {
                    return systemToReviewService.getNextSystemRoleToReview(authLogin)
                                                .then(function (response) {
                                                    return response.data;
                                                });
                }],
                systemRoleID: ['nextSystemToReview', function (nextSystemToReview) {
                    if (_.isUndefined(nextSystemToReview.SystemRole)) return null;
                    return nextSystemToReview.SystemRole.SystemRoleID;
                }],
                stateAccessReview: ['authLogin', 'systemToReviewService', function (authLogin, systemToReviewService) {
                    return systemToReviewService.getStateAccessReview(authLogin);
                }],
            }
        })

        .state('accessReview.authUser.systemToReview.systemRole', {
            url: '/{systemRoleID:[0-9]{1,20}}',
            views: {
                '': {
                    templateUrl: require('./systemToReview.tpl.html'),
                    controller: 'SystemToReviewCtrl',
                    resolve: {
                        systemToReview: ['$stateParams', 'authLogin', 'systemToReviewService', function ($stateParams, authLogin, systemToReviewService) {
                            if (_.isNull($stateParams.systemRoleID)) return null;
                            return systemToReviewService.getActualSystemRolesToReview($stateParams.systemRoleID, authLogin);
                        }],
                        systemID: ['systemToReview', function (systemToReview) {
                            if (_.isUndefined(systemToReview) || _.isNull(systemToReview)) return null;
                            return systemToReview.BusinessSystem.SystemID;
                        }],
                        systemRoleID: ['systemToReview', function (systemToReview) {
                            if (_.isUndefined(systemToReview) || _.isNull(systemToReview)) return null;
                            return systemToReview.SystemRolesToReview[0].SystemRole.SystemRoleID;
                        }],
                        relatedInfos: ['accessReview', 'systemToReview', 'systemID', 'systemRoleID',
                                       function (accessReview, systemToReview, systemID, systemRoleID) {
                                           return {
                                               accessReview: accessReview,
                                               systemToReview: systemToReview,
                                               systemID: systemID,
                                               systemRoleID: systemRoleID
                                           };
                                       }]
                    }
                },
                'sidebar@accessReview.authUser.systemToReview.systemRole': {
                    templateUrl: require('./SideBar_SystemToReview.tpl.html'),
                    controller: 'SideBar_SystemToReviewCtrl'
                }
            }
        })

        .state('accessReview.authUser.systemToReview.summary', {
            url: '/Summary',
            views: {
                '': {
                    templateUrl: require('./Summary_SystemToReview.tpl.html'),
                    controller: 'Summary_SystemToReviewCtrl',
                    resolve: {
                        nbRemainingSystemsToReview: ['authLogin', 'systemToReviewService', function (authLogin, systemToReviewService) {
                            return systemToReviewService.getNbRemainingSystemsToReview(authLogin);
                        }],
                        toRemoveEmployeeSystemRoles: ['authLogin', 'systemToReviewService', function (authLogin, systemToReviewService) {
                            return systemToReviewService.getToRemoveSystemRolesToReview(authLogin);
                        }],
                        stateAccessReview: ['authLogin', 'systemToReviewService', function (authLogin, systemToReviewService) {
                            return systemToReviewService.getStateAccessReview(authLogin);
                        }]
                    }
                },
                'sidebar@accessReview.authUser.systemToReview.summary': {
                    templateUrl: require('./SideBar_SystemToReview.tpl.html'),
                    controller: 'SideBar_SystemToReviewCtrl'
                }
            }
        })

        .state('accessReview.authUser.submitted', {
            url: '/Submitted',
            templateUrl: require('./submitted.tpl.html'),
            accessReview: ['accessReviewService', function (accessReviewService) {
                return accessReviewService.getCurrentAccessReview();
            }]
        });
}]);